import { z } from "zod";


export const noteSchema = z.object({
    subjective: z.string().min(1),
    objective: z.string().min(1),
    assessment: z.string().min(1),
    plan: z.string().min(1),
})

export const prescriptionSchema = z.object({
    medication: z.string().min(1),
    dosage: z.string().min(1),
    duration: z.string().min(1),
    cost: z.preprocess((val) => Number(val), z.number().min(0)),
    note: z.string(),
    refills: z.preprocess((val) => Number(val), z.number().min(0)),
    substitute: z.boolean(),
    reason: z.string(),
    patient_id: z.string().optional(),
    vitamin: z.object({ name: z.string() }),
}).refine(
    (data) => {
        // Vitamin is required for all medications except Zepbound
        if (data.medication !== "Zepbound (Branded Tirzepatide)") {
            return data.vitamin.name.trim().length > 0;
        }
        return true;
    },
    {
        message: "Vitamin is required",
        path: ["vitamin", "name"],
    }
)